<template>
  <div class="customer-info">
    <div class="name">
      <h1>{{ data.name?data.name: $t('page_extranet_Machine_name') }}</h1>
      <span v-if="data.userVisibleStatus === 1" class="flag">就绪</span>
      <span v-if="data.userVisibleStatus === 2" class="flag ok">连接中</span>
      <span v-if="data.id && !data.userVisibleStatus" class="flag err">未就绪</span>
    </div>
    <div class="link-wapper">
      <div class="label">
        <span class="title" style="width: 75px;">{{ $t('page_workstation_maintain_name') }}：</span>
        <a-tooltip :title="data.name" placement="top" class="value ellipsis" style="width: calc(100% - 75px)">
          {{ data.name }}
        </a-tooltip>
      </div>
      <!--<div class="label">
        <span class="title">设备序列号：</span>
        <a-tooltip :title="data.factoryNumber" placement="top" class="value ellipsis">{{ data.factoryNumber }}
        </a-tooltip>
      </div>
      <div class="label">
        <span class="title">类型：</span>
        <a-tooltip :title="data.DeviceType" placement="top" class="value ellipsis">{{ data.DeviceType }}</a-tooltip>
      </div>
      <div class="label">
        <span class="title">型号：</span>
        <a-tooltip :title="data.deviceModel" placement="top" class="value ellipsis">{{ data.deviceModel }}</a-tooltip>
      </div>-->

      <div class="label">
        <span class="title">{{$t('page_extranet_Diagnostic_channel_status')}}：</span>
        <span class="value ellipsis"
              :class="data.extranetChannelStatus?'online':'offline'">
            {{ data.extranetChannelStatus ? $t('online') :  $t('offline') }}
          </span>
      </div>
      <div class="label">
        <span class="title">{{ $t('page_extranet_Machine_SN') }}：</span>
        <a-tooltip v-if="data.gatewayToken" :title="data.gatewayToken" placement="top" class="value ellipsis">
          {{ data.gatewayToken }}
        </a-tooltip>
        <span v-if="!data.gatewayToken" class="value ellipsis"></span>
      </div>

      <template v-if="isMachineTenant">
      <div class="label">
        <span class="title">设备序列号：</span>
        <a-tooltip :title="data.equipmentSerialNumber" placement="top" class="value ellipsis">{{ data.equipmentSerialNumber }}
        </a-tooltip>
      </div>
      <div class="label">
        <span class="title">类型：</span>
        <a-tooltip :title="data.type" placement="top" class="value ellipsis">{{ data.type }}</a-tooltip>
      </div>
      <div class="label">
        <span class="title">型号：</span>
        <a-tooltip :title="data.equipmentModel" placement="top" class="value ellipsis">{{ data.equipmentModel }}</a-tooltip>
      </div>
      <div class="label">
        <span class="title">所属客户：</span>
        <a-tooltip :title="data.customerName" placement="top" class="value ellipsis">{{ data.customerName }}</a-tooltip>
      </div>
      </template>
    </div>
  </div>
</template>

<script>
import {getLocalStorage} from "@/utils/storage";

export default {
  name: 'DeviceInfo',
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      tenantClass: 0
    }
  },

  mounted() {
    this.tenantClass = getLocalStorage('USER_INFO')['tenant_classes'];
  },

  computed:{
    isMachineTenant(){
      return this.tenantClass === 4;
    }
  },
  methods: {}
}
</script>

<style scoped lang="less">
  .customer-info {
    border-bottom: 1px solid #e9e9e9;

    .name {
      margin-bottom: 16px;
      color: #5395ca;
      font-size: 16px;
      height: 48px;
      width: 100%;
      border-bottom: 1px solid #e9e9e9;

      h1 {
        height: 48px;
        font-size: 16px;
        line-height: 48px;
        color: rgba(0, 0, 0, 0.85);
        display: inline-block;
        margin-bottom: 0;

      }
    }

    .flag {
      padding: 0 4px;
      background-color: #d0edff;
      border-radius: 2px;
      border: solid 1px #4a90e2;
      color: #4a90e2;
      font-size: 10px;
      text-align: center;
      margin-left: 8px;
      display: inline-block;

      &.ok {
        color: #52c41a;
        border-color: #52c41a;
        background-color: #ddffcd;
      }

      &.err {
        color: #f74d55;
        border-color: #f74d55;
        background-color: #fef1f0;
      }
    }

    .link-wapper {
      color: rgba(0, 0, 0, 0.85);
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .label {
        width: 32%;
        margin-bottom: 16px;
        display: flex;

        .title {
          width: 105px;
          text-align: right;
        }
      }

      .value {
        color: rgba(0, 0, 0, 0.65);
        width: calc(~"100% - 105px");

        &.offline, &.online, &.err {
          position: relative;
          padding-left: 12px;

          &::before {
            position: absolute;
            content: '';
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: #faad14;
            left: 0;
            top: 40%;
          }
        }

        &.online::before {
          background-color: #52c41a;
        }

        &.err::before {
          background-color: #f5222d;
        }
      }
    }
  }
</style>
